'use client';
import { motion } from 'framer-motion';
import { IconArrowUpRight } from '@tabler/icons-react';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Cicon } from '@/components/ui/Cicon';
import { ColorType, RadiusSize } from '@/theme';
import { CWITNESSCARD_EASE_CURVE } from './cwitnesscardConstants';
import { WITNESS_CARD_HOVER_PROMPT_STYLE } from './cwitnesscardStyles';
export function CwitnesscardHoverPrompt({ isHovered }: { isHovered: boolean }) {
    return <motion.div data-el="Cwitnesscard/HoverPrompt/Root" style={WITNESS_CARD_HOVER_PROMPT_STYLE} initial={{ opacity: 0 }} animate={{ opacity: isHovered ? 1 : 0 }} transition={{ duration: 0.3, ease: CWITNESSCARD_EASE_CURVE }}>
            <Ccontainer backgroundColor={ColorType.Black} backgroundOpacity={0.5} borderColor={ColorType.White} borderOpacity={0.1} radius={RadiusSize.Rounded} padding={12} backdropBlur={10}>
                <Cicon icon={IconArrowUpRight} size={20} color={ColorType.White}/>
            </Ccontainer>
        </motion.div>
        ;
}
